import React from 'react';
import styled from 'styled-components';

import useDocumentTitle from '@hooks/useDocumentTitle';
import useViewer from '@hooks/useViewer';
import LoadingArea from '@molecules/LoadingArea';
import { DivWithShadowMediumUp, H4, SectionWrapperInner, SectionWrapperOuter } from '@styled';
import TrackPageView from '@tracking/TrackPageView';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import SectionHeader from '../../../_molecules/SectionHeader';
import TrusteeAnnouncements from '../../../_organisms/TrusteeAnnouncements';
import TrusteeLiaisonPanel from '../../../_organisms/TrusteeLiaisonPanel';
import SearchEventsTrusteePast from '../../../searches/SearchEventsTrusteePast';
import SearchEventsTrusteeUpcoming from '../../../searches/SearchEventsTrusteeUpcoming';

const HeaderContainer = styled.div`
    margin-bottom: 40px;
`;

const SectionContainer = styled.div`
    margin-bottom: 64px;
`;

const TrusteesLandingPage = () => {
    const { documentTitle } = useDocumentTitle('My ICSC Trustee Center');
    const { viewer } = useViewer();

    if (!viewer) {
        return <LoadingArea />;
    }

    // if (!viewer.isTrustee) {
    if (viewer.company?.recordId !== 5094 && ![95243, 128345, 320103].includes(viewer?.recordId)) {
        window.location.href = '/my-icsc';
        return;
    }

    return (
        <ErrorHandler>
            <TrackPageView>
                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <SectionHeader title={documentTitle} />
                        <HeaderContainer />

                        <SectionContainer>
                            <H4 className="mb-2rem">Announcements</H4>
                            <TrusteeAnnouncements />
                        </SectionContainer>

                        <SectionContainer>
                            <H4 className="mb-1.5rem">Upcoming Trustee Events</H4>
                            <DivWithShadowMediumUp>
                                <SearchEventsTrusteeUpcoming />
                            </DivWithShadowMediumUp>
                        </SectionContainer>

                        <SectionContainer>
                            <H4 className="mb-1.5rem">Past Trustee Events</H4>
                            <DivWithShadowMediumUp>
                                <SearchEventsTrusteePast />
                            </DivWithShadowMediumUp>
                        </SectionContainer>

                        <div>
                            <TrusteeLiaisonPanel />
                        </div>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

TrusteesLandingPage.propTypes = {
    //
};

export default TrusteesLandingPage;
